import React from "react";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import styled from "styled-components";
import { withStyles } from "@material-ui/core/styles";

const localStyles = () => ({
  dialogPaper: {
    "min-width": "1200px",
    "font-size": "13px"
  },
  dialogTitle: {
    color: "blue",
    padding: "0 0 0 20px",
    fontFamily: "Work Sans"
  }
});

const StyledDialog = styled(Dialog)`&&& {
  font-family: Work Sans;
}`;

const StyledDialogContent = styled(DialogContent)`&& {
  color: #666;
  min-height: ${({ minHeight }) => (minHeight ? minHeight : "150px")};
  min-width: 300px;
  && > div > div {
    border-radius: 8px 8px 0 0;
  }
  && > div > div > div {
    border-bottom: none;
  }
}`;

const StyledDialogIconButton = styled(IconButton)`&& {
  position: absolute;
  top: 8px;
  right: 13px;
}`;

const Title = styled.span`
  font-size: 24px;
  font-family: Work Sans;
  font-weight: 500;
  color: #000;
`;

export const Modal = props => {
  const { isOpen, title, onClose, closeIconShown, noPadding, children, minHeight, ...otherProps } = props;

  return (
    <StyledDialog
      modal
      fullWidth
      maxWidth="md"
      open={isOpen}
      autoDetectWindowHeight={false}
      autoScrollBodyContent={false}
      {...otherProps}
    >
      {title && (
        <DialogTitle id="form-dialog-title">
          <Title>{title}</Title>
          {closeIconShown && (
            <StyledDialogIconButton onClick={onClose}>
              <CloseIcon id="closeIcon" style={{ fontSize: 22 }} />
            </StyledDialogIconButton>
          )}
        </DialogTitle>
      )}
      <StyledDialogContent style={noPadding ? { padding: 0 } : {}} minHeight={minHeight}>
        {children}
      </StyledDialogContent>
    </StyledDialog>
  );
};

export default withStyles(localStyles)(Modal);
